// Display helpers for activity price rows ({ label, amount, currency, unit })

export const formatAmount = ({ amount, currency }) =>
  `${Number(amount).toLocaleString("en-US")} ${currency}`;

// Lowest price in the first row's currency, used for the "From" badge
export const startingPrice = (prices = []) => {
  if (!prices.length) return null;
  const currency = prices[0].currency;
  const same = prices.filter((p) => p.currency === currency);
  const lowest = same.reduce((min, p) => (p.amount < min.amount ? p : min), same[0]);
  return { ...lowest, isFrom: prices.length > 1 };
};
